import { useAuth0 } from '@auth0/auth0-react';
import { AnimatePresence } from 'framer-motion';
import { Link, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import { AccountSheet } from '../account-sheet/account-sheet';
import { IconButton } from '../button/icon-button';
import { Footer } from '../footer/footer';
import { Header } from '../header/header';
import { Terms } from '../register-screens/terms';
import { SheetContainer } from '../sheet/sheet-container';
import { SrOnly } from '../sr-only/sr-only';
import LogoSvg from '../svg/logo';
import UserSvg from '../svg/user';
import { Toasts } from './toasts';
import useActiveYear from '../../hooks/useActiveYear';

const Main = styled.main`
  margin-top: ${gutter(2)};
  min-height: 100vh;
`;

export function PageLayout() {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();

  const ACTIVE_YEAR = useActiveYear();

  return (
    <>
      <Header
        isAuthenticated={isAuthenticated}
        logo={
          <Link to={`/${ACTIVE_YEAR}/lots`}>
            <LogoSvg />
            <SrOnly>Home: Lots Page</SrOnly>
          </Link>
        }
        userIcon={
          <IconButton as={Link} to="#account" variant="tertiary">
            <UserSvg />
            <SrOnly>User Profile</SrOnly>
          </IconButton>
        }
      />
      <Toasts />
      <Main>
        <Outlet />
        <AnimatePresence exitBeforeEnter>
          {location.hash === '#account' && <AccountSheet key="account" />}
          {location.hash === '#terms' && (
            <SheetContainer
              initial={{ opacity: 0, y: 32 }}
              animate={{ opacity: 1, y: 0, transition: { duration: 0.18 } }}
              exit={{ opacity: 0, y: 32, transition: { duration: 0.18 } }}
            >
              <Terms isReadonly />
            </SheetContainer>
          )}
        </AnimatePresence>
      </Main>
      <Footer />
    </>
  );
}
